import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { OperadorService } from '@core/services/operador.service';
import { IStockArticulo } from '@models/IUltimoStock';
import { TranslateModule } from '@ngx-translate/core';
const ELEMENT_DATA: IStockArticulo[] = [];

@Component({
  selector: 'app-ultimo-stock',
  imports: [MatTableModule, CommonModule, TranslateModule],
  templateUrl: './ultimo-stock.component.html',
  styleUrl: './ultimo-stock.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UltimoStockComponent {
  readonly date = output<string>();
  readonly lugar = input<string>();

  ultimoStockDate = '';

  readonly displayedColumns: string[] = [
    'descripcionArticulo',
    'stock',
    'diasTeoricos',
    'diasPactados',
    'diferencia',
    'sobrestock',
    'ventaMedia',
  ];

  constructor(private operadorService: OperadorService) {
    this.getUltimoStock();
  }

  dataSource = new MatTableDataSource(ELEMENT_DATA);

  getUltimoStock() {
    this.operadorService.getUltimoStockAll().subscribe({
      next: (r) => {
        this.dataSource = new MatTableDataSource(r.stockArticulos);
        this.date.emit(r.fechaStock);
      },
      error: (error) => {
      },
    });
  }
}

// Artículo
// Stock teórico
// Días stock teórico (DS)
// Días stock pactados (DP)
// Diferencia (DS - DP)
// Sobrestock
// Venta media diaria
